<template>
  <div>
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow v-if="technician.id" :confirm="true"
                    :title="$t('Modify') + ' ' + $t('a') + ' ' + $t('technician')" route-back="TechnicianIndex"/>
        <back-arrow v-else :confirm="askConfirm" :title="$t('Add') + ' ' + $t('a')  + ' ' +  $t('technician')"
                    route-back="TechnicianIndex"/>
      </div>

      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm card-scrollable">
            <b-form @submit.stop.prevent="onSubmit">

              <div class="row">
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.lastName.invalidFeedback"
                    :label="$t('technician.lastName')"
                    :state="form.lastName.state"
                    class="medium-label mb-4 required-input"
                    label-for="lastName-input">
                    <b-form-input
                      id="lastName-input"
                      v-model="form.lastName.value"
                      :state="form.lastName.state"
                      maxlength="250"
                      required
                      tabindex="1"
                      type="text"
                      v-on:change="removeInvalidFeedback('lastName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.firstName.invalidFeedback"
                    :label="$t('technician.firstName')"
                    :state="form.firstName.state"
                    class="medium-label mb-4 required-input"
                    label-for="firstName-input">
                    <b-form-input
                      id="firstName-input"
                      v-model="form.firstName.value"
                      :state="form.firstName.state"
                      maxlength="250"
                      required
                      tabindex="2"
                      type="text"
                      v-on:change="removeInvalidFeedback('firstName'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-6">
                  <b-form-group
                    :invalid-feedback="form.phoneNumber.invalidFeedback"
                    :label="$t('technician.phoneNumber')"
                    :state="form.phoneNumber.state"
                    class="medium-label mb-4 required-input"
                    label-for="phoneNumber-input">
                    <vue-phone-number-input
                      id="phone-input"
                      v-model="form.phoneNumber.inputValue"
                      :error="form.phoneNumber.error"
                      tabindex="3"
                      required
                      @update="checkPhone"/>
                  </b-form-group>
                </div>

                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.username.invalidFeedback"
                    :label="$t('technician.username')"
                    :state="form.username.state"
                    class="medium-label mb-4 required-input"
                    label-for="username-input">
                    <b-form-input
                      id="username-input"
                      v-model="form.username.value"
                      :state="form.username.state"
                      required
                      tabindex="4"
                      type="email"
                      v-on:change="removeInvalidFeedback('username'); askConfirm=true;">
                    </b-form-input>
                  </b-form-group>
                </div>

                <div class="col-md-12">
                  <dropdown-department tabindex="6" :departments="departments"  :department="this.form.department"></dropdown-department>
                </div>

              </div>
              <div class="row">
                <div class=col-md-6>
                  <b-form-group
                    :invalid-feedback="form.structure.invalidFeedback"
                    :label="$t('technician.Structure')"
                    :state="form.structure.state"
                    class="medium-label mb-4"
                    v-show="structures.length !== 0"
                    label-for="structure-input">
                    <b-form-select
                      id="structure-input"
                      v-model="form.structure.value"
                      :state="form.structure.state"
                      required
                      tabindex="7"
                      v-on:change="askConfirm=true;">
                      <template v-if="structures.length === 0" #first>
                        <b-form-select-option :value="null" disabled>-- Aucune structure --</b-form-select-option>
                      </template>
                      <option v-for="option in structures" :value="option.id">
                        {{ option.tostring }}
                      </option>
                    </b-form-select>
                  </b-form-group>
                </div>

              </div>
              <div class="d-flex justify-content-end">
                <b-button tabindex="8" type="submit" variant="primary">{{ techId ? $t('Modify') : $t('Add')+' '+$t('l')+' '+$t('technician')}}</b-button>
              </div>
            </b-form>
          </b-card>
        </div>
      </div>
    </b-container>

    <user-already-exist></user-already-exist>

  </div>
</template>

<script>

import api from '../../services/api'
import BackArrow from '../../components/b122/BackArrow'
import DateField from '../../components/b122/editFields/DateField'
import PasswordCreationField from '../../components/b122/editFields/PasswordCreationField'
import DropdownDepartment from '../../components/b122/DropdownDepartment'
import UserAlreadyExist from '../user/UserAlreadyExist'
import {bus} from '../../main'

export default {

  name: 'TechnicianCreateEdit',

  components: {
    BackArrow,
    DateField,
    PasswordCreationField,
    DropdownDepartment,
    UserAlreadyExist
  },

  data () {
    return {
      techId: this.$route.params.techId,
      askConfirm: false,
      form: {
        firstName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        lastName:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        username:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        phoneNumber:
          {
            state: null,
            invalidFeedback: null,
            error: null,
            value: null,
            inputValue: null
          },

        structure:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        department: {
          state: null,
          invalidFeedback: null,
          values: [], // To hold multiple selected values
          options: [] // List of all possible department options
        }

      },
      structures: [],
      departments: [],
      technician: {}
    }
  },

  mounted () {
    this.fetchData()
  },

  created () {
    bus.$on('handleSubmit', this.submitCreateEdit)
  },
  beforeDestroy () {
    bus.$off('handleSubmit', this.submitCreateEdit)
  },

  methods: {

    async fetchAllStructure () {
      await api
        .get('/structure/getAllStructure/')
        .then(response => {
          this.structures = response.data
          if (!this.form.structure.value) {
            const defaultStructure = this.structures.find((structure) => structure.name === 'Aucune structure')
            if (defaultStructure) {
              this.form.structure.value = defaultStructure.id
            } else if (this.structures.length >= 1) {
              this.form.structure.value = this.structures[0].id
            }
          }
        })
    },

    async fetchAllDepartments () {
      await api
        .get('/technician/getAllDepartments/')
        .then(response => {
          this.departments = response.data.map(dept => {
            return {
              text: dept.tostring,
              value: dept.id
            }
          })

          this.form.department.options = this.departments
        })
    },

    async fetchData () {
      if (this.techId) {
        await this.fetchTechnician()
      }
      await this.fetchAllStructure()
      await this.fetchAllDepartments()
    },

    async fetchTechnician () {
      api
        .get('/technician/' + this.techId)
        .then(response => {
          this.technician = response.data
          if (this.technician.isDefaultTechnician) {
            this.$router.push({
              name: 'TechnicianIndex'
            },
            () => {
              this.$nextTick(() => {
                this.$bvToast.toast(this.$i18n.t('unauthorized.error'), {
                  title: this.$i18n.t('Error.title'),
                  autoHideDelay: 4000,
                  toaster: 'b-toaster-bottom-right',
                  solid: true
                })
              })
            })
          }
          this.setInitialValues()
        })
    },

    async onSubmit () {
      await this.fetchUserAlreadyExist()
    },

    async fetchUserAlreadyExist () {
      let data = new FormData()
      data.append('objectType', 'Technician')
      if (this.technician.id) {
        data.append('objectId', this.technician.id)
      }
      data.append('username', this.form.username.value)
      await api({
        method: 'post',
        url: '/user/isUserAlreadyExist',
        data: data
      })
        .then(async (response) => {
          if (response.status === 200) {
            await this.submitCreateEdit()
          } else if (response.status === 202) {
            if (response.data.user) {
              bus.$emit('toggleModal', response.data.user)
            }
          }
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'TechnicianIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    async submitCreateEdit () {
      let data = new FormData()
      data.append('firstName', this.form.firstName.value)
      data.append('lastName', this.form.lastName.value)
      data.append('username', this.form.username.value)
      data.append('phoneNumber', this.form.phoneNumber.value.e164)
      data.append('department', this.form.department.values)
      data.append('structureId', this.form.structure.value)

      let url = 'technician'
      if (this.techId) {
        url = '/technician/' + this.techId
      }

      await api({
        method: 'POST',
        url: url,
        data: data
      })
        .then((response) => {
          this.structure = response.data
          this.$router.push({
            name: 'TechnicianIndex'
          },
          () => {
            this.$nextTick(() => {
              this.successToast(this.form.username.value)
            })
          })
        })
        .catch((error) => {
          this.$bvModal.hide('user-already-exist-modal')
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'TechnicianIndex'
            })
          } else {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    setInitialValues () {
      if (this.technician != null) {
        this.form.firstName.value = this.technician.user.firstName
        this.form.lastName.value = this.technician.user.lastName
        this.form.username.value = this.technician.user.username
        this.form.phoneNumber.value = this.technician.user.phoneNumber
        this.form.phoneNumber.inputValue = this.technician.user.phoneNumber
        this.form.department.value = this.technician.department
        this.form.structure.value = this.technician.structure.id
        this.form.department.values = this.formatDepartment(this.technician.department)
      }
    },

    formatDepartment (value) {
      return value.map(item => Number(item.id))
    },
    successToast (taskName) {
      this.$bvToast.toast(this.$i18n.t('Technician') + ' "' + taskName + '" ' + this.$i18n.t('f.registered.object'), {
        autoHideDelay: 4000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true
      })
    },

    removeInvalidFeedback (field) {
      this.form[field]['state'] = null
    },

    checkPhone (value) {
      this.form.phoneNumber.error = false
      this.form.phoneNumber.value = value
      this.removeInvalidFeedback('phoneNumber')
      this.askConfirm = true
    }

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/technician/TechnicianCreateEdit.vue